import { DEFAULT_GUIDE_ID } from './registry';
import type { GuideLocation, GuideMeta } from './types';

function routeMatches(pathname: string, route: string): boolean {
  const p = pathname.toLowerCase().replace(/\/+$/, '');
  const r = route.toLowerCase().replace(/\/+$/, '');
  return p === r || p.startsWith(`${r}/`);
}

/**
 * Pick the guide for a location: a `match` predicate wins, then the longest
 * matching `routes` prefix, then the default guide.
 */
export function matchGuide(
  location: GuideLocation,
  guides: GuideMeta[]
): GuideMeta {
  const byPredicate = guides.find((g) => g.match?.(location));
  if (byPredicate) return byPredicate;

  let best: GuideMeta | undefined;
  let bestLength = -1;
  for (const guide of guides) {
    for (const route of guide.routes ?? []) {
      if (routeMatches(location.pathname, route) && route.length > bestLength) {
        best = guide;
        bestLength = route.length;
      }
    }
  }
  return best ?? guides.find((g) => g.id === DEFAULT_GUIDE_ID) ?? guides[0];
}
